export default __webpack_public_path__ + "static/munmun2-29998e330c10298a0f4daf3cbf338038.jpg";